import { render, staticRenderFns } from "./UsersActivities.vue?vue&type=template&id=1b561b73&scoped=true&"
import script from "./UsersActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./UsersActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b561b73",
  null
  
)

export default component.exports